<template>
    <form class="new-pay3__lesson-form" ref="lessonForm">
        <div class="new-pay3__form-content">
            <div class="new-pay3__form-basic-info">
                <div  class="new-pay3__form-item new-pay3__grade-subject">
                    <select class="new-pay3__form-item--content new-pay3__grade" v-model="weakGrade" ref="grade">
                        <option :value="value" v-for="({label, value}) in subjectGrade" :key="value" >{{ label }}</option>
                    </select>
                    <select class="new-pay3__form-item--content  new-pay3__subject" v-model="weakSubject" ref="subject">
                        <option :value="value" v-for="({label, value}) in weakSubjectArr" :key="value">{{ label }}</option>
                    </select>
                </div>

                <div class="new-pay3__form-item">
                    <input type="text" placeholder="请输入孩子的姓名" class="new-pay3__form-item--content  new-pay3__username" :class="{ alert: userNameAlert }" v-model="userName"  />
                </div>
                <div class="new-pay3__form-item">
                    <span class="area-code" @click="showCountry = true">+{{areaCode}}</span>
                    <input type="number" placeholder="请输入上课联系手机号" :class="{ alert: mobileAlert }" class="new-pay3__tel new-pay3__form-item--content " v-model="mobile" maxlength="11"  />
                </div>
            </div>

        </div>

        <img class="new-pay3__zm-btn" href="javascript:;" src="https://static-app-manager.zmlearn.com/WRE4Z84j7270.png" @click="handleSubmitBtn()">

        <div class="new-pay3__form-protocol">
            <img :src="getCheckedIcon" @click="checkProtocol = !checkProtocol" class="new-pay3__checkoutImg" alt />
            <div>
                <span @click="checkProtocol = !checkProtocol"  class="new-pay3__form-protocol--text">同意我们的</span>
                <span @click.stop="showProtocol = true" class="new-pay3__form-protocol--high-light">《用户隐私条款》</span>
            </div>
        </div>
        <div class="new-pay3__info">
            <img class="new-pay3__lock" src="https://web-data.zmlearn.com/image/vRuqLVCMvKdxPdhcoQBoCv/%E5%BD%A2%E7%8A%B6.png" />
            <span>为了您的权益，您的隐私将被严格保密</span>
        </div>
        <protocol :showProtocol.sync="showProtocol"></protocol>
        <fail-dialog ref="failDialog"></fail-dialog>
        <country v-model="showCountry" @select="areaCode = $event"></country>
    </form>
</template>

<script>
    import api from "@/api";
    import cookies from 'js-cookie';
    import {
        request,
        queryObj,
        isEmptyObject,
    } from "@/utils/util";
    import urlConfig from "@/config";
    import Protocol from "@/components/lesson-form/protocol";
    import failDialog from "@/components/fail-dialog/fail-dialog";
    import Toast from "@/base/toast/toast";
    import BindForm from "@/components/bindForm/index";
    import BindFormComponent from "@/components/bindForm/create";
    import country from '../country/index.vue';
    export default {
        name: "lesson-form",
        components: {
            failDialog,
            Protocol,
            country,
        },
        props: ['type'],
        data() {
            return {
                getCode: "获取验证码",
                codeCountDownNum: 60,
                codeCountSubmitNum: 3,
                areaCode: 86,
                showCountry: false,
                userName: "",
                weakGrade: "小三",
                weakSubject: "数理逻辑训练",
                mobile: "",
                userNameAlert: false,
                mobileAlert: false,
                checkProtocol: true,
                showProtocol: false,
                open_id: "",
                changMobile: false,
                subjectGrade:  [
                    {"label":"幼儿园中班","value":"幼儿园中班"},
                    {"label":"幼儿园大班","value":"幼儿园大班"},
                    {"label":"小一","value":"小一"},
                    {"label":"小二","value":"小二"},
                    {"label":"小三","value":"小三"}
                ],
                weakSubjectArr: [
                    {"label":"语文思维训练","value":"语文思维训练"},
                    {"label":"数理逻辑训练","value":"数理逻辑训练"}
                ],
                iconCheckState: {
                    checked: 'https://web-data.zmlearn.com/image/ut7ZfqyGo5aSiWmLPWCdCr/%E7%BC%96%E7%BB%84%205.png',
                    unchecked: 'https://web-data.zmlearn.com/image/7cCwbkGdtrLweuC3eEEHSw/%E6%A4%AD%E5%9C%86%E5%BD%A2.png'
                },
                isSubmitting: false,
        };
        },
        filters: {
            filterPhoneNumber(number) {
                if (number.length === 11) {
                    let pat = /(\d{3})\d*(\d{4})/;
                    return (number = number.replace(pat, "$1****$2"));
                }
            },
        },
        watch: {
            userName() {
                this.userNameAlert = false;
            },
            mobile() {
                this.mobileAlert = false;
                this.changMobile = true;
            },
        },
        created () {
          if (this.type === 'chinese') {
              this.weakSubject = '语文思维训练'
          }  
        },
        mounted() {
        },
        computed: {
            codeCountDown() {
                if (this.codeCountDownNum === 60 || this.codeCountDownNum <= 0) {
                    return this.getCode;
                } else {
                    return this.codeCountDownNum + "s";
                }
            },
            getCheckedIcon () {
                const { checked, unchecked } = this.iconCheckState;
                return this.checkProtocol && checked || unchecked;
            },
        },

        methods: {
            // 验证表单
            validateForm() {
                return new Promise((resolve, reject) => {
                    if (!/^([a-zA-Z]|[\u4e00-\u9fa5]){1,}$/.test(this.userName)) {
                        this.userNameAlert = true;
                        reject("请填写正确的孩子姓名");
                    } else if (this.userName.length >= 7) {
                        this.userNameAlert = true;
                        reject("请填写正确的孩子姓名");
                    } else if (this.mobile.length === 0) {
                        this.mobileAlert = true;
                        reject("请输入手机号");
                    } else if (!this.checkProtocol) {
                        reject("请同意用户隐私协议");
                    } else {
                        resolve("success");
                    }
                });
            },

            // 埋点
            doTrack(position) {
                if ( ZM_JSSDK) {
                    let eventData = {
                        eventId: position.event_id,
                        eventParam: {
                            name: position.event_name,
                            grade: this.weakGrade,
                            subject: this.weakSubject,
                            trigger_site: position.trigger_site,
                            position: position.position
                        },
                    };
                    ZM_JSSDK.sendEvent(eventData);
                }
            },

            // 验证表单并注册
            async handleSubmitBtn() {
                ZM_JSSDK &&
                ZM_JSSDK.sendEvent({
                    eventId: this.type === 'math' ? 'click_kid_act24_ljlq' : 'click_kid_act25_ljlq',
                    eventParam: {
                        code: this.$route.query.channel_code,
                        position: '1'
                    }
                });
                if (this.isSubmitting) { return;}
                this.isSubmitting = true;
                try {
                    await this.validateForm();
                    await this.doRegister();
                } catch (e) {
                    Toast(e);
                } finally {
                    this.isSubmitting = false;
                }
            },

            // 注册
            async doRegister() {
                const gradeMap = {
                    '小三': 'PRIMARY_SCHOOL_3',
                    '小二': 'PRIMARY_SCHOOL_2',
                    '小一': 'PRIMARY_SCHOOL_1',
                    '幼儿园大班': 'KINDERGARTEN_3',
                    '幼儿园中班': 'KINDERGARTEN_2'
                }
                const subjectMap = {
                    '语文思维训练': 'CHINESE_LOGIC',
                    '数理逻辑训练': 'MATH_LOGIC',
                    '英语': 'ENGLISH_CONCEPT',
                    '钢琴陪练': 'PIANO_PARTNER',
                    '小提琴陪练': 'VIOLIN',
                    '北美外教': 'NORTH_AMERICAN_TEACHERS'
                }
                try {
                    const res = await api.appointnoSms({
                        areaCode: this.areaCode,
                        name: this.userName,
                        stuGradeCode: gradeMap[this.weakGrade],
                        weakSubjectCode: subjectMap[this.weakSubject],
                        mobile: this.mobile,
                        checkCodeFlag: true,
                        comeFrom: this.$route.name,
                        code: this.$route.query.channel_code || "",
                        key: this.$route.query.channel_keyword || "",
                    })
                    if (res.code * 1 === 0) {
                        ZM_JSSDK &&
                        ZM_JSSDK.sendEvent({
                            eventId: this.type === 'math' ? 'enter_kid_act24_success' : 'enter_kid_act25_success',
                            eventParam: {
                                phone_num: `${this.areaCode}-${this.mobile}`,
                                code: this.$route.query.channel_code,
                            }
                        });
                        fbq('track', 'Lead');
                        window.snaptr && window.snaptr('track', 'SIGN_UP');
                        setTimeout(() => {
                            this.$router.push({
                            name: this.areaCode === 86 ? 'appointment-success-kid' : 'appointment-success-kid-not86',
                            params: {
                                mobile: this.areaCode === 86 ? this.mobile : `${this.areaCode}-${this.mobile}`,
                                flatfrom: this.$route.name || '',
                                grade: this.weakGrade,
                                channel_code: this.$route.query.channel_code,
                                channel_keyword: this.$route.query.channel_code,
                                showPeilian: false
                            },
                        });
                        }, 300);
                    } else {
                        Toast(res.message);
                    }
                } catch (e) {
                    Toast(e);
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    $theme: #ff6e35;
    $fz-protocol: px2rem(22);
    $bgColor: #fff;
    $black0: #000;
    $black3: #333;
    $black6: #666;
    $black9: #999;
    $space: px2rem(14);
    .area-code {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        margin-right: px2rem(7);
        border-radius: px2rem(20);
        padding-left: px2rem(19);
        width: px2rem(126);
        height: px2rem(86);
        background: #EEEEEE;
        font-size: px2rem(28);
        color: #999999;
        box-sizing: border-box;
    }
    @mixin utils-flex($align-item: center, $justify-content: center, $direction: row, $wrap: nowrap) {
        display: flex;
        align-items: $align-item;
        justify-content: $justify-content;
        flex-flow: $direction $wrap;
    }
    .new-pay3{
        &__lesson-form {
            overflow: hidden;
            width: px2rem(688);
            height: px2rem(886);
            background: url('https://static-app-manager.zmlearn.com/tKEKA2hi2687.png') no-repeat px2rem(-12) 0 / cover;
        }
        &__form-content {
            margin-top: px2rem(178);
        }
        &__form-item {
            width: 100%;
            padding: 0 px2rem(32) px2rem(16);
            box-sizing: border-box;
            @include utils-flex;
            &--content{
                width: 100%;
                height: px2rem(86);
                padding: 0 px2rem(20);
                border-radius: px2rem(20);
                border: none;
                box-sizing: border-box;
                color: #202020;
                background: #eee;
                font-size: px2rem(28);

                &::placeholder {
                    color: #999;
                }
            }
        }
        &__grade-subject {
            justify-content: space-between;
        }
        &__grade,
        &__subject{
            position: relative;
            width: 48%;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            background: url('https://web-data.zmlearn.com/image/8kzGTUynStSU5ZM1u8uSqm/arrow_03.png') no-repeat 90% center transparent;
            background-size: px2rem(26) px2rem(16);
            background-color: #eee;
            padding: 0 px2rem(30) 0 px2rem(20);
            font-size: px2rem(28);
        }
        &__title {
            font-size: px2rem(55);
            padding: px2rem(40);
            color: $theme;
        }
        &__send-code {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            right: px2rem(60);
            border-radius: px2rem(10);
            width: px2rem(181);
            height: px2rem(66);
            background: #FF7533;
            font-size: px2rem(28);
            color: #fff;
        }
        &__form-protocol {
            @include utils-flex;
            &--text {
                font-size: $fz-protocol;
                color: #2B2B2B;
            }
            &--high-light {
                font-size: $fz-protocol;
            }
            &--high-light {
                color: $theme;
            }
        }
        &__checkoutImg {
            width: px2rem(26);
            margin-right: $space;
        }
        &__lock {
            width: px2rem(18);
            margin-right: $space;
        }
        &__info {
            margin-top: px2rem(20);
            color: #575757;
        }
        &__zm-btn {
            width: px2rem(634);
            height: px2rem(138);
        }
    }

</style>